import React, { useState } from 'react';
import { Modal, Box, Button, TextField, Typography, IconButton, InputAdornment } from '@mui/material';
import { toast } from 'react-toastify';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { patchApi } from 'views/services/api';
import { useTranslation } from 'react-i18next';

const ChangePassword = ({ open, handleClose, email, onChangePassword }) => {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePasswordChange = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error(t('Please fill in all fields'));
      return;
    }
    
    if (newPassword !== confirmPassword) {
      toast.error(t('Passwords do not match!'));
      return;
    }

    if (newPassword.length < 6) {
      toast.error(t('Password must be at least 6 characters long'));
      return;
    }

    setLoading(true);
    try {
      console.log("Api Hit ===>", `api/user/changeAdminPassword`, { email: email, password: newPassword });
      const response = await patchApi('api/user/changeAdminPassword', { email: email, password: newPassword });
      console.log("response aaya ===>", response);
      
      if (response.status === 200 && response.data.success) {
        toast.success(t('Password changed successfully'));
        setNewPassword('');
        setConfirmPassword('');
        handleClose();
      } else {
        toast.error(response.data?.message || t('Failed to change password'));
      }
    } catch (error) {
      console.error('Error changing password:', error);
      toast.error(error.response?.data?.message || t('Failed to change password'));
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setNewPassword('');
    setConfirmPassword('');
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <Box sx={{ ...modalStyle }}>
        <Typography variant="h6" component="h2" gutterBottom>
          {t('Change Password')}
        </Typography>
        <TextField 
          label={t('Email Address')} 
          value={email} 
          fullWidth 
          margin="normal" 
          InputProps={{ readOnly: true }} 
        />
        <TextField
          label={t('New Password')}
          type={showNewPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <TextField
          label={t('Confirm Password')}
          type={showConfirmPassword ? 'text' : 'password'}
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                  {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 2 }}>
          <Button 
            variant="contained" 
            onClick={handlePasswordChange}
            disabled={loading}
            sx={{ 
              backgroundColor: '#673ab7',
              '&:hover': {
                backgroundColor: '#5e35b1'
              }
            }}
          >
            {loading ? t('Changing...') : t('Change Password')}
          </Button>
          <Button 
            variant="outlined" 
            color="error" 
            onClick={handleCloseModal}
            disabled={loading}
          >
            {t('Cancel')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
};

export default ChangePassword;
